module.exports = __webpack_public_path__ + "static/media/IPAD-ASTOUND-BANNER.6ce955b4.webp";